/* jshint node:true */
'use strict';

var React = require('react');

var Conversation = React.createClass({

    displayName: 'Conversation',

    componentDidMount: function(){
        try {
            espn.plugins.getFacebook( function(){
                if(!$(".fb-comments iframe").length){
                    FB.XFBML.parse(document.body);
                }
            });
        }catch(e){}
    },
    
    shouldComponentUpdate: function(nextProps, nextState) {
        return false;
    },

    render: function () {
        var query = this.props.query;
        var sPageUrl        = 'http://www.espn.co.uk/rugby/conversation?gameId=' + (query.gameId || query.eventId) + '&league=' + (query.leagueId || query.league);
        
        return (
            <article className="sub-module conversation">
            	<header className="bordered">
            		<h1>Conversation</h1>
            	</header>
            	<div className="content">
            		<p className="condition">Use a <a href="https://www.facebook.com/r.php" rel="nofollow">Facebook account</a> to add a comment, subject to Facebook's <a href="https://www.facebook.com/policies/" rel="nofollow">Terms of Service</a> and <a href="https://www.facebook.com/about/privacy/" rel="nofollow">Privacy Policy</a>. Your Facebook name, photo &amp; other personal information you make public on Facebook will appear with your comment, and may be used on ESPN's media platforms. <a href="http://espn.go.com/community/story/_/id/8756098/espn-facebook-comments-faq">Learn more</a>.</p>
                    <div className="fb-comments" data-numposts="5" data-href={sPageUrl} data-width="100%"></div>
            	</div>
            </article>
        );
    }
});

module.exports = Conversation;







/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/Conversation.jsx
 **/